import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Megaphone, X } from 'lucide-react';
import { API_BASE } from '../../config/api';

const API = `${API_BASE}/api`;

export default function AnnouncementsBanner({ token }) {
  const [items, setItems] = useState([]);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/announcements/mine`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setItems((r.data.announcements || []).filter((a) => !a.read)))
      .catch(() => {});
  }, [token]);

  const dismiss = (id) => {
    setItems((prev) => prev.filter((a) => a.notification_id !== id));
    axios.post(`${API}/regulatory/notifications/${id}/read`, {}, { headers }).catch(() => {});
  };

  if (!items.length) return null;
  return (
    <div className="space-y-3 mb-8" data-testid="announcements-banner">
      {items.slice(0, 3).map((a) => (
        <div key={a.notification_id} className="flex gap-3 rounded-xl border border-navigate-gold/30 bg-navigate-gold/10 p-4" data-testid={`announcement-${a.notification_id}`}>
          <Megaphone className="h-5 w-5 text-navigate-gold shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-white font-semibold text-sm">{a.title}</p>
            <p className="text-zinc-300 text-sm whitespace-pre-line mt-1">{a.message}</p>
            <p className="text-[11px] text-zinc-500 mt-2">{new Date(a.created_at).toLocaleDateString('en-ZA', { dateStyle: 'medium' })}</p>
          </div>
          <button onClick={() => dismiss(a.notification_id)} className="text-zinc-400 hover:text-white h-fit" aria-label="Dismiss" data-testid={`dismiss-announcement-${a.notification_id}`}><X className="h-4 w-4" /></button>
        </div>
      ))}
    </div>
  );
}
